/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Passkey_Required_BodyInputs */

const en_add_passkey_required_body = /** @type {(inputs: Add_Passkey_Required_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're signed in with a recovery code. Create a passkey on this device to continue.`)
};

const de_add_passkey_required_body = /** @type {(inputs: Add_Passkey_Required_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist mit einem Wiederherstellungscode angemeldet. Erstelle einen Passkey auf diesem Gerät, um weiterzumachen.`)
};

/**
* | output |
* | --- |
* | "You're signed in with a recovery code. Create a passkey on this device to continue." |
*
* @param {Add_Passkey_Required_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const add_passkey_required_body = /** @type {((inputs?: Add_Passkey_Required_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Passkey_Required_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_add_passkey_required_body(inputs)
	return en_add_passkey_required_body(inputs)
});